import { atom } from "@mongez/react-atom";
import type { BrowserHelpReason } from "../trusted-device-fallback";

export const resetPasswordAtom = atom({
  key: "resetPassword",
  default: {
    code: "",
    email: "",
    phoneNumber: "",
    // Used for sending the verify code to api
    // if valid, then it will be cleared
    // code must be used instead in the reset password
    tempOTP: "",
  },
});

export const telegramLoginAtom = atom({
  key: "telegramLogin",
  default: {
    phoneOrEmail: "",
    otpCode: "",
    isOTPSent: false,
  },
});

export const verifyRegisterAtom = atom({
  key: "verifyRegister",
  default: {
    code: "",
    email: "",
    phoneNumber: "",
    verificationType: "email" as "email" | "phoneNumber",
  },
});
/**
 * Advice panel shown under a login/register form when this browser cannot
 * complete any trusted-device method (open in Chrome, leave private mode,
 * switch to HTTPS). `null` hides the panel.
 */
export const loginBrowserHelpAtom = atom<{ reason: BrowserHelpReason | null }>({
  key: "loginBrowserHelp",
  default: {
    reason: null,
  },
});
